import styled from 'styled-components';

export const DivFileOptions = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  svg {
    color: var(--blue);
  }
  h3 {
    margin-bottom: 2rem;
    text-align: center;
  }
`;
